<template>
  <div class="preloader" :class="`lang-${locale}`">
    <div class="spinner-blink" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineOptions({
  name: "preloader",
});

const { locale } = useI18n();
</script>

<style lang="scss">
@import "./index.scss";
</style>
